import React from "react";

export default function Play({ data }) {
  return <>{<iframe src={data.iframe}></iframe>}</>;
}
